<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import AutocompleteField from '@/components/Selector/AutocompleteField.vue'
import { TypographyItem } from '@/components/Typography'
import deviceApi from '@/services/device.service'
import type { DeviceModel } from '@/types/models/DeviceModel'
import { EDebounceTime } from '@/utils/debounceUtils'
import { useDebounceFn } from '@vueuse/core'
import { onMounted, ref } from 'vue'

const emit = defineEmits<{
    (e: 'refresh'): void
    (e: 'select', device: DeviceModel): void
}>()

const device = ref()

const isLoadingDevices = ref(false)
const handleChange = (value: string) => {
    isLoadingDevices.value = true
    debouncedQuestion(value)
}
const debouncedQuestion = useDebounceFn((value: string) => getDevices(value), EDebounceTime.DEFAULT)
const getDevices = (name?: string) =>
    deviceApi
        .getDevices(name ? { filters: { name } } : {})
        .then(res => (devicesOptions.value = res.data))
        .finally(() => (isLoadingDevices.value = false))

const devicesOptions = ref<DeviceModel[]>([])

onMounted(() => getDevices())

const handleSelect = (value: DeviceModel) => emit('select', value)
</script>

<template>
    <AutocompleteField
        :label="$t('detection.filters.device')"
        v-model="device"
        :loading="isLoadingDevices"
        @typing="handleChange"
        @select="handleSelect($event as DeviceModel)"
        :options="devicesOptions"
        class="width-fit">
        <template #default="props">
            <StackLayout direction="column">
                <TypographyItem :label="props.option.name" />
                <TypographyItem :label="`SN : ${props.option.serial_number}`" />
            </StackLayout>
        </template>
    </AutocompleteField>
</template>
